// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picList-container[data-v-49a4c400] {\n  padding-left: 20px;\n}\n.picList-container .title[data-v-49a4c400] {\n  font-weight: 550;\n  margin: 0;\n}\n.picList-container .el-upload-list__item-actions i[data-v-49a4c400] {\n  font-size: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
